<template>
    <div class = "item-bar">
        <cart></cart>
        <a  class="menu-item" v-for="(topMenuItemData,i) in menuItemDatas" :key ="topMenuItemData.key" target='_blank' :href="topMenuItemData.url" v-if="i<1">
            <img :style="styleObject" :src= topMenuItemData.icon>
            <span>{{topMenuItemData.name}}</span>
        </a>
        <el-dropdown v-if="menuItemDatas.length>=2">
            <el-button type="text" size="medium">
                {{this.$store.state.malMainPageConfig.constant.more}}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(topMenuItemData,i) in menuItemDatas" :key="topMenuItemData.key" v-if="i>=1">
                    <a  class="drop-menu-item"  target='_blank' :href="topMenuItemData.url" >
                        <!--<img :style="styleObject" :src= topMenuItemData.icon>-->
                        <span>{{topMenuItemData.name}}</span>
                    </a>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>
<script>
    import Cart from './Cart.vue'
    export default {
        components:{
            'cart':Cart
        },
        data(){
            return {
                
            }
        },
        methods:{

        },
        computed: {
            styleObject: function () {
//                let data = this.$props.data;
                return {
                    /*'background-image': 'url(' + data.icon + ')',*/
                    width: '18px',
                    height: '20px',
                    'margin-right': '4px ',
                    display: 'inline-block',
                    color : 'white'
                }
            },
            menuItemDatas:function(){
                return this.$store.state.malMainPageConfig.topMenuItem;
            }
        }
    }
</script>

<style scoped lang="scss">
    .item-ap{
        display: flex;
        align-items:center ;
    }
    .menu-item {
        display: flex;
        align-items:center ;
        text-decoration: none;
        color: #ebeef5;
        font-family: PingFangSC-Regular;
        margin-left: 20px;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 1;
    }
    .drop-menu-item {
        display: flex;
        align-items:center ;
        text-decoration: none;
        color: black;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 1;
        margin-top: 5px;
    }
    .item-bar{
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        height: 24px;
        margin-bottom: 10px;
        align-items: center;
    }
    .el-button--text {
        color: #ebeef5;
    }
    .el-dropdown {
        margin-left: 20px;
        display: flex;
        align-items: center;
        height: 20px;
    }
    .el-button{
      /* line-height: 0;*/
    }

    /*.el-dropdown-menu {
        background-color: white;
        border: 1px solid #EBEEF5;
    }*/
</style>
